module.exports = __webpack_public_path__ + "static/img/ham.d89d6720.webp";